<!-- Zweck: Stellt die HTML-Struktur für app nav bar component im Frontend bereit. -->
<mat-toolbar [class.printhidden]="(isPrinting|async)" class="app-header mat-elevation-z1" color="primary"
  [style.background-color]="(nbBgColor|async) ? (nbBgColor|async)+' !important': ''"
  [style.color]="(nbFontColor|async) ? (nbFontColor|async)+' !important' : ''"
  [class.mobile]="isMobile|async"
  [class.desktop]="!(isMobile|async)">
  <table>
    <tr>
      <td class="td1">
        <a class="logo" routerLink="/" [class.hidden]="((isMobile|async) && (hasBack|async))" [class.disabled]="disabled|async">
          <img alt="Logo" src="{{domainConfig.logofilename}}" [class.hidden]="(nbInversedLogo|async)">
          <img alt="Logo" src="{{domainConfig.logofilenameInversed}}" [class.hidden]="!(nbInversedLogo|async)">
        </a>

        @if ((isMobile|async) && (hasBack|async)) {
          <div class="backButtonBox">
            <button (click)="nbsvc.triggerBack()"  [disabled]="disabled|async" class="navbarbackbutton tut_dashboard_button" mat-button
              matTooltip="Zurück">
              <svg-icon>zurueck</svg-icon>
            </button>
          </div>
        }

        <button routerLink="/dashboard" routerLinkActive="active" [disabled]="disabled|async"  class="mainmenubutton tut_dashboard_button" mat-button
          matTooltip="Zum Dashboard"
          [routerLinkActiveOptions]="{'exact': true}">
          <svg-icon>dashboard</svg-icon>
        </button>

        <main-menu-button [disabled]="disabled|async"></main-menu-button>
      </td>
      <td class="td2">
        @if (!(isMobile|async)) {
          <div>
            <div style="display: inline-block">
              <div [class.hidden]="(nbLabel|async) ? true:false">
                {{domainConfig.pagetitle}}
              </div>
              @if (nbLabel|async) {
                <div>
                  {{nbLabel|async}}
                </div>
              }
            </div>
            <permission-block [oneOfRoles]="['Vertreter']">
              @if (cfg.vertreterconfig.value && cfg.vertreterconfig.value.DomainVertreterShowLkndInHead) {
                <div style="display: inline-block; margin-left: 50px">
                  @if ((currentLieferkunde|async)) {
                    <a style="font-size: 11px; line-height: 11px" class="tut_lieferkunde_button" routerLink="/lieferkunden" matTooltip="Lieferanschrift  wechseln"
                      [class.lieferkundeButtonHoverOpacity]="!!(nbBgLinkColor|async)"
                      [style.color]="(nbBgLinkColor|async) ? (nbBgLinkColor|async)+' !important' : ''"
                      >
                      @if (domainConfig.show_customer_numbers) {
                        <span>
                          <svg-icon verticalAlign="top">lieferadresse</svg-icon>
                          @if (!(isMobile|async)) {
                            <div style="display: inline-block; text-align: left; padding-top: 1px; padding-left: 5px">
                              @if (domainConfig.showA2KndNrOverwrite == 'A2KndNrDefault') {
                                {{(currentLieferkunde|async)?.A2KndNrDefault}}
                              }
                              @if (domainConfig.showA2KndNrOverwrite == 'A2KndNrOrganisationseinheit') {
                                {{(currentLieferkunde|async)?.A2KndNr}}
                              }
                              @if (domainConfig.showA2KndNrOverwrite == 'Nein') {
                                {{(currentLieferkunde|async)?.LieferkundeNr}}
                              }
                              - {{(currentLieferkunde|async)?.Vorname}} <br> {{(currentLieferkunde|async)?.Nachname}}
                            {{(currentLieferkunde|async)?.Ort}}</div>
                          }
                        </span>
                      }
                      @if (!domainConfig.show_customer_numbers) {
                        <span>
                          <svg-icon verticalAlign="top">lieferadresse</svg-icon>
                          @if (!(isMobile|async)) {
                            <div style="display: inline-block; text-align: left; padding-top: 1px; padding-left: 5px">
                              {{(currentLieferkunde|async)?.Vorname}} <br> {{(currentLieferkunde|async)?.Nachname}}
                            {{(currentLieferkunde|async)?.Ort}}</div>
                          }
                        </span>
                      }
                    </a>
                  }
                </div>
              }
            </permission-block>
          </div>
        }
      </td>
      <td class="td3">
        @if (!(isMobile|async) && !(disabled|async)) {
          <div style="display: inline-block">
            <app-clock position="navbar"></app-clock>
            <global-search-box></global-search-box>
            <permission-block [oneOfRoles]="['Auftrag']">
              <app-warenkorb-menu></app-warenkorb-menu>
            </permission-block>
            <app-notifications></app-notifications>
            <differential-lk-banner></differential-lk-banner>
            <app-user-menu></app-user-menu>
          </div>
        }
        @if (!(isMobile|async) && (disabled|async) && (nbsvc.show_logout$|async)) {
          <div style="display: inline-block">
            @if ((usvc.user$|async)?.impersonated_by) {
              <button mat-button (click)="depersonate()" matTooltip="Depersonate" aria-label="Depersonate">
                <svg-icon>logout</svg-icon>
                Depersonate
              </button>
            }
            <button mat-button routerLink="/logout" matTooltip="Abmelden" aria-label="Abmelden">
              <svg-icon>logout</svg-icon>
              Abmelden
            </button>
          </div>
        }
        @if ((isMobile|async)) {
          <div style="display: inline-block">
            <permission-block [oneOfRoles]="['Auftrag']">
              <app-warenkorb-menu></app-warenkorb-menu>
            </permission-block>
            <app-notifications></app-notifications>
          </div>
        }

        @if ((isMobile|async)) {
          <div style="display: inline-block;">
            <button (click)="showMenu2()" [class.active]="active2|async" class="" mat-button>
              @if (!(active2|async)) {
                <mat-icon>expand_less</mat-icon>
              }
              @if ((active2|async)) {
                <mat-icon>expand_more</mat-icon>
              }
            </button>
          </div>
        }

      </td>
    </tr>
  </table>
</mat-toolbar>

@if ((isMobile|async) && (!(disabled|async) || (nbsvc.show_logout$|async))) {
  <div [class.hidden]="!(active2|async)" class="mainmenu2 mat-elevation-z1">
    @if (!(disabled|async)) {
      <global-search-box></global-search-box>
      <br>
        <differential-lk-banner></differential-lk-banner>
        <app-user-menu></app-user-menu>
      }
      @if ((disabled|async) && (nbsvc.show_logout$|async)) {
        @if ((usvc.user$|async)?.impersonated_by) {
          <button mat-button (click)="depersonate()" matTooltip="Depersonate" aria-label="Depersonate">
            <svg-icon>logout</svg-icon>
            Depersonate
          </button>
        }
        <button mat-button routerLink="/logout" matTooltip="Abmelden" aria-label="Abmelden">
          <svg-icon>logout</svg-icon>
          Abmelden
        </button>
      }
    </div>
  }
